import React from "react";
import Image from "next/image";
import Link from "next/link";
import { getLocalizedPath } from "@/components/shared/formatURL";

interface TagCardProps {
  tag: any;
  style: string;
  translations: any;
  state: any;
}

const TagCard: React.FC<TagCardProps> = ({ tag, style, state, translations }) => {
  //const newURL = getLocalizedPath(`tags/${tag._id}?style=${style}&type=master`); // All posts with this master tag
  const searchURL = getLocalizedPath(`post/search?search=${tag.names[translations.key]}&style=${style}`);

  return (
    //links are wrapped 3 times to fix an iOS safari bug
    <div
      className={`tag-card relative overflow-hidden ${
        state.expandContent ? "" : "border-[#3C3C3C] sm:rounded-lg sm:border-[0.5px] sm:shadow-lg"
      }`}
    >
      {tag.featuredImageUrl ? (
        <Link prefetch={false} className="relative" href={searchURL}>
          <Image
            src={tag.featuredImageUrl}
            alt={`Tag ${tag._id}`}
            className="h-48 w-full object-cover"
            layout="responsive"
            width={2}
            height={3}
            loading="lazy"
          />
        </Link>
      ) : (
        <Link prefetch={false} className="relative" href={searchURL}>
          <Image
            src={`https://cdn6.imgpog.com/defaultugc.webp`}
            alt={`Tag ${tag._id}`}
            className="h-48 w-full object-cover"
            layout="responsive"
            width={2}
            height={3}
            loading="lazy"
          />
        </Link>
      )}
      {/* Overlay user text on the bottom left of the image */}
      {tag.author && (
        <div className="px-auto text-md absolute bottom-0 left-0 w-full whitespace-nowrap bg-black bg-opacity-50 py-2 text-center font-semibold text-white sm:text-lg">
          <Link prefetch={false} href={searchURL}>
            {tag.names[translations.key] || "Unnamed Tag"}
          </Link>
        </div>
      )}
    </div>
  );
};

export default TagCard;
